import ReportTemplateItem from '../Domain/ReportTemplateItem';
import AuthService from './authService';

export default class ReportTemplateService {
  static GetReportTemplateList() {
    return AuthService.getInstance().CallBackendFunction('/api/ReportTemplate/ListAsync');
  }

  static postReportTemplateFile(data) {
    var authService = AuthService.getInstance();

    var url = '/api/ReportTemplate/PostReportTemplateFile/';

    return authService.CallBackendFunctionPostFile(url, data);
  }

  static async EditReportTemplateFileAsync(data) {
    var authService = AuthService.getInstance();
    var url = '/api/ReportTemplate/EditReportTemplateFileAsync/';
    return authService.CallBackendFunctionPostFile(url, data);
  }

  static postUploadReportTemplateFile(data) {
    var authService = AuthService.getInstance();

    var url = '/api/ReportTemplate/PostUploadReportTemplateFile/';

    return authService.CallBackendFunctionPostFile(url, data);
  }

  static ConvertDBReportTemplate(reportTemplates) {
    var convertedList = [];
    if (reportTemplates !== null) {
      reportTemplates.forEach((item) => {
        var newItem = new ReportTemplateItem(item);
        convertedList.push(newItem);
      });
    }

    return convertedList;
  }

  static RemoveReportTemplateFile(id) {
    var authService = AuthService.getInstance();

    var url = '/api/ReportTemplate/RemoveTemplateFileAsync/?reportTemplateId=' + id;

    return authService.CallBackendFunction(url);
  }

  static getReportTemplateFile(id) {
    var url = '/api/ReportTemplate/DownloadFileById/' + id;
    let authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }
}
